import styled from 'styled-components'

export default styled.div`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.3rem;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/WidgetPickerRow/Header.js